export default {
  meta: {
    title: '项目管理'
  }
};
